import React from 'react'
import styles from './styles.module.scss'
import NameOrEmail from './NameOrEmail'

interface NameOrEmailItem {
  name?: string
  email?: string
}

interface NameOrEmailListProps {
  nameOrEmails?: NameOrEmailItem[]
}

const NameOrEmailList: React.FC<NameOrEmailListProps> = ({ nameOrEmails }) => {
  if (!nameOrEmails?.length) {
    return null
  }

  return (
    <div className={styles.nameOrEmailList}>
      {nameOrEmails.map(({ name, email }, idx) => (
        <span key={`${name}-${email}`}>
          <NameOrEmail name={name} email={email} />
          {idx !== nameOrEmails.length - 1 && <>,&nbsp;</>}
        </span>
      ))}
    </div>
  )
}

export default NameOrEmailList
